import { AUTOCOMPLETE_SECTION_PREFIXES } from 'bundles/search-common/constants/autocomplete';

export const ZERO_STATE_AUTOCOMPLETE_AI_PROMPTS_DISPLAY_LIMIT = 6;

export const DEFAULT_QUERY_PROMPTS_FETCH_LIMIT = 10;

export const ASK_ANYTHING_AI_PROMPT_ID = `${AUTOCOMPLETE_SECTION_PREFIXES.AI_PROMPTS_ZERO_STATE}ask-anything`;
export const ASK_ANYTHING_ROUTE_TYPE = 'coach_ask_anything';
